:host {
  display: block;
  --table-row-size: var(--spacing-scale-3x);
  --br-table-divider-base-width: var(--surface-width-sm);
}

.br-table {
  width: 100%;
}

.br-table-content {
  display: grid;
  grid-template-columns: var(--br-table-column-widths);
  min-width: 0;
}
